import * as types from './types'
import SendBird from 'sendbird'
import sendbird from './sendbird.js'
import store from '@/store'

export default {
  [types.INIT_SENDBIRD](state, apiId) {
    sendbird.sendbird = new SendBird({
      appId: apiId
    })
    return sendbird.sendbird
  },
  [types.RESET_MESSAGES](state) {
    state.messages = []
  },
  [types.RESET_CHAT_MESSAGES](state) {
    state.chatHistory = []
  },
  [types.SET_CHAT_MESSAGES](state, dates) {
    state.chatHistory = dates
    state.messages = []
    let language = store.getters['auth/language']
    let userProfile = store.getters['auth/userProfile']
    if (dates !== undefined && dates !== null) {
      if (dates.Dates !== undefined && dates.Dates !== null) {
        for (let date of dates.Dates) {
          for (let message of date.Messages) {
            var type = 'received'
            var name = ''
            var createdAt = date.Date
            createdAt += ' ' + message.Message.DateTime
            if (message.Message.Source === 'user') {
              type = 'sent'
              name = 'me'
              if (userProfile.email !== message.Message.Username) {
                name = message.Message.Username
              }
            } else {
              name = message.Message.Operator
            }
            let messageText = message.Message.Message
            if (message.Translations !== undefined && message.Translations !== null) {
              if (message.Translations.length > 0) {
                for (let translation of message.Translations) {
                  if (translation.Language.substring(0, 2) === language) {
                    messageText = translation.Message
                    break
                  }
                }
              }
            }
            var data = {
              name: name,
              type: type,
              contentType: message.type,
              text: messageText,
              avatar: '',
              createdAt: createdAt,
              email: message.Username,
              messageId: message.Id
            }
            state.messages.push(data)
          }
        }
      }
    }
  },
  [types.ADD_MESSAGE](state, message) {
    let userProfile = store.getters['auth/userProfile']
    let language = store.getters['auth/language']
    let type = 'received'
    let name = message._sender.nickname
    if (userProfile.email === message._sender.userId) {
      type = 'sent'
      name = 'me'
    }
    let messageText = message.message
    if (message.translations[language] !== undefined && message.translations[language] !== null) {
      messageText = message.translations[language]
    }
    let data = {
      name: name,
      type: type,
      messageType: 'user',
      contentType: message.type,
      text: messageText,
      avatar: '',
      createdAt: message.createdAt,
      email: message._sender.userId,
      messageId: message.messageId
    }
    state.messages.push(data)
  },
  [types.ADD_ATTACHMENT_MESSAGE](state, message) {
    let userProfile = store.getters['auth/userProfile']
    // let language = store.getters['auth/language']
    let type = 'received'
    let name = message._sender.nickname
    if (userProfile.email === message._sender.userId) {
      type = 'sent'
      name = 'me'
    }
    let messageText = message.message
    // if (message.translations[language] !== undefined && message.translations[language] !== null) {
    //   messageText = message.translations[language]
    // }
    let data = {
      name: name,
      type: type, // Should have been "direction"
      messageType: 'file',
      contentType: message.type,
      text: messageText,
      plainUrl: message.plainUrl,
      avatar: '',
      createdAt: message.createdAt,
      email: message._sender.userId,
      messageId: message.messageId
    }
    state.messages.push(data)
  },
  [types.SET_TYPING](state, channel) {
    state.isTyping = false
    if (channel !== undefined && channel !== null) {
      state.isTyping = true
    }
    setTimeout(() => {
      store.dispatch('sendbird/setTyping', null)
    }, 2500)
  },
  [types.SET_MESSAGECOUNTS](state, counts) {
    if (counts !== undefined && counts !== null) {
      state.directMessageCount = counts
    }
  },
  [types.RESET_CHANNELS](state) {
    state.channels = []
    state.token = ''
  },
  [types.SET_CHANNELS](state, data) {
    if (data !== undefined && data !== null) {
      for (let channel of data.channels) {
        if (channel.unread_message_count > 0) {
          state.channels.push(channel)
        }
      }
      state.token = data.next
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/mutations.js